// extracted by mini-css-extract-plugin
export default {"capitalize":"validated-view_capitalize__CUqYj"};